import { render, staticRenderFns } from "./EqifyAvatar.vue?vue&type=template&id=ad271c1a&scoped=true"
import script from "./EqifyAvatar.vue?vue&type=script&lang=ts"
export * from "./EqifyAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad271c1a",
  null
  
)

export default component.exports